import React from 'react';

import { FormRenderProps } from 'react-final-form';
import isEqual from 'lodash/isEqual';

import { Button } from '@vk-hr-tek/ui/Button';
import { Dialog, DialogContent } from '@vk-hr-tek/ui/Dialog';

import {
  ContentSurveysFormContent,
  ContentSurveysFormContainer,
} from '../form';
import { ContentSurveysFormValues } from '../../types';

interface ContentSurveysDialogProps {
  isOpen: boolean;
  onClose: VoidFunction;
  editContentSurvey: ContentSurveysFormValues | null;
  onSave: (formData: ContentSurveysFormValues) => void;
}

export const ContentSurveysDialog = ({
  isOpen,
  onSave,
  onClose,
  editContentSurvey,
}: ContentSurveysDialogProps) => {
  const handleFormSubmit =
    ({
      handleSubmit,
      form: currentForm,
    }: FormRenderProps<ContentSurveysFormValues>) =>
    async () => {
      await handleSubmit();

      const formState = currentForm.getState();

      if (formState.hasValidationErrors) return;

      onSave(formState.values);
      onClose();
    };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <ContentSurveysFormContainer editContentSurvey={editContentSurvey}>
        {(form) => {
          //TODO: Refactoring
          const normalizedInitialValues = {
            ...form.initialValues,
            questions: (form?.initialValues?.questions ?? []).map(
              (question) => ({
                ...question,
                content: {
                  ...question.content,
                  data:
                    typeof question.content.data !== 'string'
                      ? question.content.data
                      : JSON.parse(question.content.data),
                },
              }),
            ),
          };

          const normalizeFormValues = {
            ...form.values,
            questions: (form.values.questions ?? []).map((question) => ({
              ...question,
              content: {
                ...question.content,
                data:
                  typeof question.content.data !== 'string'
                    ? question.content.data
                    : JSON.parse(question.content.data),
              },
            })),
          };

          const isContentSurveysChanged = !isEqual(
            normalizeFormValues,
            normalizedInitialValues,
          );

          return (
            <DialogContent
              onClose={onClose}
              title={`${!editContentSurvey ? 'Создание' : 'Редактирование'} опроса`}
              actions={
                <>
                  <Button
                    onClick={onClose}
                    size="large"
                    variant="tertiaryLight"
                  >
                    Отменить
                  </Button>

                  <Button
                    size="large"
                    type="submit"
                    variant="tertiaryLight"
                    loading={form.submitting}
                    onClick={handleFormSubmit(form)}
                    disabled={
                      !isContentSurveysChanged || form.hasValidationErrors
                    }
                  >
                    {!editContentSurvey ? 'Создать' : 'Изменить'}
                  </Button>
                </>
              }
            >
              <ContentSurveysFormContent
                editContentSurvey={editContentSurvey}
              />
            </DialogContent>
          );
        }}
      </ContentSurveysFormContainer>
    </Dialog>
  );
};
